import { Component, HostBinding, Input } from '@angular/core'

@Component({
    selector: 'mg-checkout-accordion-content',
    template: '<ng-content></ng-content>',
    styleUrls: ['./checkout-accordion-content.component.scss'],
})
export class CheckoutAccordionContentComponent {
    @Input()
    @HostBinding('class._is_active')
    isActive: boolean = false
}
